<template>
  <div class="stock__alert">
    <vs-card class="cardx bg-green-500">
      <vs-table stripe maxHeight="500px" :sst="true" @change-page="handleChangePage" @sort="handleSort" :total="total" pagination :max-items="this.limit" :data="stock_alerts">
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center w-full mb-3">
            <p class="font-bold text-xl">Stock Alert</p>
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <span class="mr-2 text-base">
                {{ page * limit - (limit - (total && 1)) }}
                -
                {{ total - page * limit > 0 ? page * limit : total }}
                of {{ total }} (filtered from {{ total }} total entries)
              </span>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th sort-key="category.category_name">Category Name</vs-th>
          <vs-th sort-key="product.product_name">Item Name</vs-th>
          <vs-th sort-key="product.quantity">Stock</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>
              {{ tr.category.category_name }}
            </vs-td>
            <vs-td>
              {{ tr.product_name }}
            </vs-td>
            <vs-td>
              {{ tr.quantity | weightFilter }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { weightMixins } from '@/utils/weightType'

export default {
  name: 'StockAlert',

  data() {
    return {
      page: 1,
      limit: 5,
      order: []
    }
  },

  mixins: [weightMixins],

  async mounted() {
    // get stock alerts
    await this.get_stock_results()
  },

  methods: {
    ...mapActions('dashboard', { fetch_stock_alerts: 'getStockAlerts' }),

    // get stock result
    async get_stock_results() {
      try {
        const payload = {
          page: this.page,
          limit: this.limit,
          order: this.order
        }

        await this.fetch_stock_alerts(payload)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // handle change page
    handleChangePage(page) {
      this.page = page
      this.get_stock_results()
    },

    // sort the data in table
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.get_stock_results()
    }
  },

  computed: {
    ...mapState('dashboard', ['stock_alerts', 'total'])
  },

  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>

<style></style>
